<template>
  <div class="mainC" style="background: #141416; color: lightgrey">
    <div class="">
      <div
        class=""
        style="height: 12px !important; background: #141416 !important"
      ></div>
      <li
        v-if="leaderList.length == 0"
        class="list-group-item listHeader"
        style="
          border-radius: 0px;
          background: #212225;
          font-size: 12px;
          color: #e6e6e6;
          height: 40px;
        "
      >
        <img style="margin-bottom: 3px" src="@/assets/noInfo.svg" />{{
          $t("LanguageEn.noInfoa")
        }}
      </li>
      <div v-else>
        <li
          class="container"
          style="
            color: #e6e6e6;
            background: #212225;
            height: 34px;
            line-height: 34px !important;
            list-style-type: none;
            font-size: 12px;
          "
        >
          <div class="row">
            <div class="col-4">
              {{ $t("LanguageEn.season") }}
            </div>
            <div class="col">
              {{ $t("LanguageEn.winner") }}
            </div>
            <div class="col">
              {{ "Status" | transliterate(cookiesObject.lang) }}
            </div>
          </div>
        </li>
        <li
          v-for="(some, i) in leaderList"
          :key="i"
          style="
            height: 40px;
            border: none;
            font-size: 12px;
            background: #141416;
            padding-left: 15px;
          "
          class="container list-group-item"
        >
          <div class="row">
            <div
              class="col-4"
              style="color: #e6e6e6; border-bottom: 1px solid #2c2d31"
            >
              <span v-if="some.season"
                >{{ some.season.name | transliterate(cookiesObject.lang) }}
              </span>
              <span v-else
                >{{ some.seasonName | transliterate(cookiesObject.lang) }}
              </span>
            </div>
            <div
              class="col MobileHide"
              style="color: #e6e6e6; border-bottom: 1px solid #2c2d31"
            >
              <img
                :src="teamLogo + some.team.id"
                alt=""
                style="width: 20px; padding-bottom: 5px"
              />
              {{ some.team.name | transliterate(cookiesObject.lang) }}
            </div>
            <div
              class="col ml-0 pl-0 MobileShow"
              style="color: #e6e6e6; border-bottom: 1px solid #2c2d31"
            >
              <img
                :src="teamLogo + some.team.id"
                alt=""
                style="width: 20px; padding-bottom: 5px"
              />
              <span v-if="some.team.shortCode">
                {{
                  some.team.shortCode | transliterate(cookiesObject.lang)
                }} </span
              ><span v-else>
                {{
                  some.team.name.slice(0, 3) | transliterate(cookiesObject.lang)
                }}</span
              >
            </div>
            <div
              class="col"
              style="color: #e6e6e6; border-bottom: 1px solid #2c2d31"
            >
              {{ some.status | transliterate(cookiesObject.lang) }}
            </div>
          </div>
        </li>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Archive",
  data() {
    return {
      leaderList: [],
      cookiesObject: "",
      tabIndex: 0,
      teamLogo: "https://sportapi.zuniac.com/team/logo/",
      id: "",
    };
  },
  async beforeMount() {
    this.id = this.$route.params.leagueId;

    var cookiesObject = document.cookie
      .split(";")
      .map((cookie) => cookie.split("="))
      .reduce(
        (accumulator, [key, value]) => ({
          ...accumulator,
          [key.trim()]: decodeURIComponent(value),
        }),
        {}
      );
    this.cookiesObject = cookiesObject;

    this.getList();
  },

  methods: {
    getList() {
      var myHeaders = new Headers();
      myHeaders.append(
        "Cookie",
        "__cfduid=daa11664c49161bf93cd02dbd6c4fb8131611146765"
      );

      var requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(
        this.httpReq +
          "/tournament/" +
          this.id +
          "/winners?token=" +
          this.cookiesObject.token,
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          this.leaderList = result.tournamentTrophies;
        })
        .catch((error) => console.log("error", error));
    },
  },
  components: {},
  computed: {
    ...mapGetters(["httpReq"]),
  },
};
</script>

<style scoped>
.first {
  background: #355d38;
}
.second {
  background: #6e552f;
}
.other {
  background: #3c3e43;
}
.last {
  background: #79323a;
}

.mainC {
  margin-top: 0px !important;
}

.LeagueName {
  margin-bottom: 10px;
}

.header {
  background: #d6d6d6;
  color: black;
}

.bodyElement {
  padding: 0;
  height: 28px;
}

.game {
  text-align: center;
}
.game :hover {
  color: #309a3d;
}

@media only screen and (max-width: 770px) {
  body {
    background: #212529;
  }
  .MobileHide {
    display: none;
  }
}

@media only screen and (min-width: 770px) {
  .MobileShow {
    display: none;
  }
}
</style>
